var map = {
	"./access-denied/access-denied.module": [
		"./src/app/dashboard/access-denied/access-denied.module.ts",
		"access-denied-access-denied-module"
	],
	"./category/category.module": [
		"./src/app/dashboard/category/category.module.ts",
		"common",
		"category-category-module"
	],
	"./client/client.module": [
		"./src/app/dashboard/client/client.module.ts",
		"client-client-module"
	],
	"./deal/deal.module": [
		"./src/app/dashboard/deal/deal.module.ts",
		"common",
		"deal-deal-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts"
	],
	"./map/map.module": [
		"./src/app/dashboard/map/map.module.ts",
		"map-map-module"
	],
	"./not-found/not-found.module": [
		"./src/app/dashboard/not-found/not-found.module.ts",
		"not-found-not-found-module"
	],
	"./period/period.module": [
		"./src/app/dashboard/period/period.module.ts",
		"common",
		"period-period-module"
	],
	"./profile/profile.module": [
		"./src/app/dashboard/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./template/template.module": [
		"./src/app/dashboard/template/template.module.ts",
		"template-template-module"
	],
	"./unit/unit.module": [
		"./src/app/dashboard/unit/unit.module.ts",
		"common",
		"unit-unit-module"
	],
	"./user/user.module": [
		"./src/app/dashboard/user/user.module.ts",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;